var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvailableRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "28px",
    viewBox: "0 0 22 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 1@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1",
    transform: "translate(11.000000, 14.000000) scale(-1, 1) translate(-11.000000, -14.000000) "
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#F22B5D",
    points: "18.7830923 25.279831 18.7830923 2.09926082 11.5150167 2.09926082 11.5150167 0 3.17797553 2.09926082 2.99777531 2.09926082 2.99777531 25.250264 -1.42073853e-13 25.250264 -1.42073853e-13 25.9303062 3.29810901 25.9303062 11.4849833 28 11.4849833 2.77930306 18.0923248 2.77930306 18.0923248 25.9303062 22 25.9303062 22 25.250264 18.7830923 25.250264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99989054,14.500652 C10.0055291,14.7598808 9.79271022,14.9988087 9.50425088,15 C9.21116309,15.0011948 9.00137448,14.7676515 9,14.5008179 C8.99859997,14.226341 9.22898643,13.9985397 9.50385452,14 C9.77745682,14.0014617 9.99967318,14.2257285 9.99989054,14.500652",
    id: "Fill-15",
    fill: "#FFFFFF",
    transform: "translate(9.500000, 14.500000) scale(-1, 1) translate(-9.500000, -14.500000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableRoom);
export default __webpack_public_path__ + "static/media/availableRoom.b1cadb396cb9d7d66031fe4c4addc136.svg";
export { ForwardRef as ReactComponent };